import { PolicyLayout, PolicySection } from "@/components/PolicyLayout";

export default function LocationPolicy() {
  return (
    <PolicyLayout
      testId="location-page"
      seoTitle="Location Permissions & Usage — Foodie Crave"
      seoDescription="Why Foodie Crave uses location, when it is used, and how to manage or revoke location permissions."
      seoPath="/location"
      title="Location Permissions & Usage"
      updated="October 20, 2026"
    >
      <PolicySection title="1. Why Foodie Crave Uses Location">
        <p>
          Foodie Crave is designed to help you discover restaurants, food trucks, cafés, and other
          food and beverage establishments.
        </p>
        <p>When location access is enabled, Foodie Crave may:</p>
        <ul className="list-disc space-y-2 pl-5">
          <li>Display nearby restaurants and food establishments</li>
          <li>Center the Discover map around your current location</li>
          <li>Provide geographically relevant search results</li>
          <li>Help you explore dining options nearby</li>
        </ul>
      </PolicySection>

      <PolicySection title="2. Location Permission Is Optional">
        <p>
          You may choose whether to grant location permission. If you decline, you can still search
          for restaurants by manually entering a city, state, ZIP code, or other supported location.
          Some features may be limited without location access.
        </p>
      </PolicySection>

      <PolicySection title="3. When Location Is Used">
        <p>
          Location is requested only when necessary to provide supported features. Foodie Crave does
          not require continuous background location tracking.
        </p>
        <p>
          <span className="font-semibold text-crave-cream">Where location is stored.</span> Foodie
          Crave does not store your device location on our servers. Your coordinates are used only
          in the moment of a search request to Google Places and then discarded. Your most recent
          search area may be cached locally on your device for convenience; this cache never leaves
          your phone and is removed when you uninstall the app or delete your account.
        </p>
      </PolicySection>

      <PolicySection title="4. Location Information and Third Parties">
        <p>
          Location information may be processed by mapping and infrastructure providers (Google
          Maps / Places) to support restaurant searches and map displays, subject to their
          respective privacy policies.
        </p>
      </PolicySection>

      <PolicySection title="5. Managing Location Permissions">
        <p>
          You can manage or revoke device location permission through your device settings at any
          time. Manual city/ZIP search remains available after disabling device location.
        </p>
      </PolicySection>

      <PolicySection title="6. Contact">
        <p>
          For more information, see our Privacy Policy, Data Retention &amp; Account Deletion
          Policy, or email{" "}
          <a
            href="mailto:support@foodiecrave.app"
            className="font-medium text-crave-gold transition-colors duration-300 hover:text-crave-cream"
          >
            support@foodiecrave.app
          </a>
          .
        </p>
      </PolicySection>
    </PolicyLayout>
  );
}
